import React from 'react';
import { HomeIcon, AppleIcon, SpecialIcon, MoreIcon } from './Icons';
import './BottomNavigation.css';

const BottomNavigation = () => {
  const navItems = [
    { icon: HomeIcon, label: 'Home', active: true },
    { icon: AppleIcon, label: 'Products', active: false },
    { icon: SpecialIcon, label: 'Special', active: false },
    { icon: MoreIcon, label: 'More', active: false }
  ];

  return (
    <nav className="bottom-navigation">
      <div className="nav-container">
        {navItems.map((item, index) => {
          const IconComponent = item.icon;
          return (
            <div key={index} className="nav-item">
              <div className={`nav-icon-container ${item.active ? 'active' : ''}`}>
                <div className="nav-icon">
                  <IconComponent />
                </div>
              </div>
              <span className="nav-label">{item.label}</span>
            </div>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation; 